import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class MaintanceGuard implements CanActivate {

    constructor(public router: Router) {}

    canActivate(): boolean {
        if(environment.isMaintenance) {
            this.router.navigate(['/karbantartas']);
            return false;
        }
        return true;
    }
}